"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { DELEGATION_CONTRACT } from "@/constants";
import { DelegationCenterSection } from "@/enums";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Toast, ToastContainer } from "react-bootstrap";
import { useEnsName } from "wagmi";
import { sepolia } from "wagmi/chains";
import CollectionDelegationComponent from "./CollectionDelegation";
import styles from "./Delegation.module.scss";
import DelegationCenterComponent from "./DelegationCenter";
import NewAssignPrimaryAddress from "./NewAssignPrimaryAddress";
import NewConsolidationComponent from "./NewConsolidation";
import NewDelegationComponent from "./NewDelegation";
import NewSubDelegationComponent from "./NewSubDelegation";
import { ANY_COLLECTION, GRADIENTS_COLLECTION, MEMES_COLLECTION, MEME_LAB_COLLECTION } from "./delegation-constants";
import DelegationHTML from "./html/DelegationHTML";
import WalletCheckerComponent from "./walletChecker/WalletChecker";
interface Props {
  section: DelegationCenterSection;
  path?: string[];
  setActiveSection(section: DelegationCenterSection): any;
  address_query: string;
  setAddressQuery(address: string): any;
  collection_query: string;
  setCollectionQuery(collection: string): any;
  use_case_query: number;
  setUseCaseQuery(use_case: number): any;
}
export default function DelegationCenterMenu(props) {
  const $ = _c(94);
  const pathname = usePathname();
  const accountResolution = useSeizeConnectContext();
  const t0 = accountResolution.address as `0x${string}`;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      address: t0,
      chainId: 1
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ensResolution = useEnsName(t1);
  const toastRef = useRef(null);
  const [toast, setToast] = useState(undefined);
  const [showToast, setShowToast] = useState(false);
  let t2;
  let t3;
  if ($[2] !== showToast) {
    t2 = () => {
      if (!showToast) {
        setToast(undefined);
      }
    };
    t3 = [showToast];
    $[2] = showToast;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== toast) {
    t4 = () => {
      if (toast) {
        setShowToast(true);
      }
    };
    t5 = [toast];
    $[5] = toast;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== accountResolution.address || $[9] !== ensResolution || $[10] !== props) {
    t6 = function printContent() {
      switch (props.section) {
        case DelegationCenterSection.CENTER:
          {
            return <DelegationCenterComponent setSection={section_3 => props.setActiveSection(section_3)} />;
          }
        case DelegationCenterSection.REGISTER_DELEGATION:
          {
            return <NewDelegationComponent address={accountResolution.address as string} ens={ensResolution.data} collection_query={props.collection_query} setCollectionQuery={props.setCollectionQuery} use_case_query={props.use_case_query} setUseCaseQuery={props.setUseCaseQuery} onHide={() => {
              props.setActiveSection(DelegationCenterSection.CENTER);
            }} onSetToast={toast_3 => {
              setToast({
                title: toast_3.title,
                message: toast_3.message
              });
            }} />;
          }
        case DelegationCenterSection.REGISTER_SUB_DELEGATION:
          {
            return <NewSubDelegationComponent address={accountResolution.address as string} ens={ensResolution.data} onHide={() => {
              props.setActiveSection(DelegationCenterSection.CENTER);
            }} onSetToast={toast_2 => {
              setToast({
                title: toast_2.title,
                message: toast_2.message
              });
            }} />;
          }
        case DelegationCenterSection.REGISTER_CONSOLIDATION:
          {
            return <NewConsolidationComponent address={accountResolution.address as string} ens={ensResolution.data} onHide={() => {
              props.setActiveSection(DelegationCenterSection.CENTER);
            }} onSetToast={toast_1 => {
              setToast({
                title: toast_1.title,
                message: toast_1.message
              });
            }} />;
          }
        case DelegationCenterSection.ASSIGN_PRIMARY_ADDRESS:
          {
            return <NewAssignPrimaryAddress address={accountResolution.address as string} ens={ensResolution.data} onHide={() => {
              props.setActiveSection(DelegationCenterSection.CENTER);
            }} onSetToast={toast_0 => {
              setToast({
                title: toast_0.title,
                message: toast_0.message
              });
            }} new_primary_address_query={props.address_query} setNewPrimaryAddressQuery={props.setAddressQuery} />;
          }
        case DelegationCenterSection.ANY_COLLECTION:
          {
            return <CollectionDelegationComponent collection={ANY_COLLECTION} setSection={section_2 => props.setActiveSection(section_2)} />;
          }
        case DelegationCenterSection.MEMES_COLLECTION:
          {
            return <CollectionDelegationComponent collection={MEMES_COLLECTION} setSection={section_1 => props.setActiveSection(section_1)} />;
          }
        case DelegationCenterSection.MEME_LAB_COLLECTION:
          {
            return <CollectionDelegationComponent collection={MEME_LAB_COLLECTION} setSection={section_0 => props.setActiveSection(section_0)} />;
          }
        case DelegationCenterSection.GRADIENTS_COLLECTION:
          {
            return <CollectionDelegationComponent collection={GRADIENTS_COLLECTION} setSection={section => props.setActiveSection(section)} />;
          }
        case DelegationCenterSection.WALLET_ARCHITECTURE:
          {
            return <DelegationHTML title="Wallet Architecture" path="reference-overview-wallet-architecture" />;
          }
        case DelegationCenterSection.FAQ:
          {
            return <DelegationHTML title="Delegation FAQ" path="delegation-faq" />;
          }
        case DelegationCenterSection.CONSOLIDATION_USE_CASES:
          {
            return <DelegationHTML title="Consolidation Use Cases" path="consolidation-use-cases" />;
          }
        case DelegationCenterSection.HTML:
          {
            return <DelegationHTML path={props.path && props.path[props.path?.length - 1]} />;
          }
        case DelegationCenterSection.CHECKER:
          {
            return <WalletCheckerComponent address_query={props.address_query} setAddressQuery={props.setAddressQuery} />;
          }
      }
    };
    $[8] = accountResolution.address;
    $[9] = ensResolution;
    $[10] = props;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const printContent = t6;
  let t7;
  if ($[12] !== props) {
    t7 = () => props.setActiveSection(DelegationCenterSection.CENTER);
    $[12] = props;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.CENTER ? styles.menuLeftItemActive : ""}`;
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <Row className="pt-2 pb-2"><Col onClick={t7} className={t8}>Delegation Center</Col></Row>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== props) {
    t10 = () => props.setActiveSection(DelegationCenterSection.WALLET_ARCHITECTURE);
    $[17] = props;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.WALLET_ARCHITECTURE ? styles.menuLeftItemActive : ""}`;
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <Row className="pt-1 pb-2"><Col onClick={t10} className={t11}>Wallet Architecture</Col></Row>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== props) {
    t13 = () => props.setActiveSection(DelegationCenterSection.FAQ);
    $[22] = props;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.FAQ || props.section === DelegationCenterSection.HTML && pathname?.startsWith("/delegation/delegation-faq/") ? styles.menuLeftItemActive : ""}`;
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = <Row className="pt-1 pb-2"><Col onClick={t13} className={t14}>Delegation FAQs</Col></Row>;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== props) {
    t16 = () => props.setActiveSection(DelegationCenterSection.CONSOLIDATION_USE_CASES);
    $[27] = props;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.CONSOLIDATION_USE_CASES ? styles.menuLeftItemActive : ""}`;
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <Row className="pt-1 pb-2"><Col onClick={t16} className={t17}>Consolidation Use Cases</Col></Row>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== props) {
    t19 = () => props.setActiveSection(DelegationCenterSection.CHECKER);
    $[32] = props;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  const t20 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.CHECKER ? styles.menuLeftItemActive : ""}`;
  let t21;
  if ($[34] !== t19 || $[35] !== t20) {
    t21 = <Row className="pt-1 pb-2"><Col onClick={t19} className={t20}>Wallet Checker</Col></Row>;
    $[34] = t19;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Row className="pt-2 pb-2"><Col><EtherscanLink /></Col></Row>;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Row className="pt-2 pb-2"><Col><GithubLink /></Col></Row>;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== t12 || $[40] !== t15 || $[41] !== t18 || $[42] !== t21 || $[43] !== t9) {
    t24 = <Col className={styles.menuLeft}><Container>{t9}{t12}{t15}{t18}{t21}{t22}{t23}</Container></Col>;
    $[39] = t12;
    $[40] = t15;
    $[41] = t18;
    $[42] = t21;
    $[43] = t9;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== printContent) {
    t25 = printContent();
    $[45] = printContent;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t25) {
    t26 = <Col className={styles.menuRight}>{t25}</Col>;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t24 || $[50] !== t26) {
    t27 = <Row>{t24}{t26}</Row>;
    $[49] = t24;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== props) {
    t28 = () => props.setActiveSection(DelegationCenterSection.CENTER);
    $[52] = props;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  const t29 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.CENTER ? styles.menuLeftItemActive : ""}`;
  let t30;
  if ($[54] !== t28 || $[55] !== t29) {
    t30 = <Row className="pt-2 pb-2"><Col onClick={t28} className={t29}>Delegation Center</Col></Row>;
    $[54] = t28;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== props) {
    t31 = () => props.setActiveSection(DelegationCenterSection.WALLET_ARCHITECTURE);
    $[57] = props;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  const t32 = `${styles.menuLeftItem} ${props.section == DelegationCenterSection.WALLET_ARCHITECTURE ? styles.menuLeftItemActive : ""}`;
  let t33;
  if ($[59] !== t31 || $[60] !== t32) {
    t33 = <Row className="pt-1 pb-2"><Col onClick={t31} className={t32}>Wallet Architecture</Col></Row>;
    $[59] = t31;
    $[60] = t32;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== props) {
    t34 = () => props.setActiveSection(DelegationCenterSection.FAQ);
    $[62] = props;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  const t35 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.FAQ ? styles.menuLeftItemActive : ""}`;
  let t36;
  if ($[64] !== t34 || $[65] !== t35) {
    t36 = <Row className="pt-1 pb-2"><Col onClick={t34} className={t35}>Delegation FAQs</Col></Row>;
    $[64] = t34;
    $[65] = t35;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== props) {
    t37 = () => props.setActiveSection(DelegationCenterSection.CONSOLIDATION_USE_CASES);
    $[67] = props;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  const t38 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.CONSOLIDATION_USE_CASES ? styles.menuLeftItemActive : ""}`;
  let t39;
  if ($[69] !== t37 || $[70] !== t38) {
    t39 = <Row className="pt-1 pb-2"><Col onClick={t37} className={t38}>Consolidation Use Cases</Col></Row>;
    $[69] = t37;
    $[70] = t38;
    $[71] = t39;
  } else {
    t39 = $[71];
  }
  let t40;
  if ($[72] !== props) {
    t40 = () => props.setActiveSection(DelegationCenterSection.CHECKER);
    $[72] = props;
    $[73] = t40;
  } else {
    t40 = $[73];
  }
  const t41 = `${styles.menuLeftItem} ${props.section === DelegationCenterSection.CHECKER ? styles.menuLeftItemActive : ""}`;
  let t42;
  if ($[74] !== t40 || $[75] !== t41) {
    t42 = <Row className="pt-1 pb-2"><Col onClick={t40} className={t41}>Wallet Checker</Col></Row>;
    $[74] = t40;
    $[75] = t41;
    $[76] = t42;
  } else {
    t42 = $[76];
  }
  let t43;
  if ($[77] !== t30 || $[78] !== t33 || $[79] !== t36 || $[80] !== t39 || $[81] !== t42) {
    t43 = <Col><Container className="no-padding">{t30}{t33}{t36}{t39}{t42}</Container></Col>;
    $[77] = t30;
    $[78] = t33;
    $[79] = t36;
    $[80] = t39;
    $[81] = t42;
    $[82] = t43;
  } else {
    t43 = $[82];
  }
  let t44;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <Row className="pt-2 pb-2"><Col><EtherscanLink /></Col></Row>;
    $[83] = t44;
  } else {
    t44 = $[83];
  }
  let t45;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <Col><Container className="no-padding">{t44}<Row className="pt-2 pb-2"><Col><GithubLink /></Col></Row></Container></Col>;
    $[84] = t45;
  } else {
    t45 = $[84];
  }
  let t46;
  if ($[85] !== t43) {
    t46 = <Row className="pt-4"><Col className={styles.menuLeftFull}><Container><Row>{t43}{t45}</Row></Container></Col></Row>;
    $[85] = t43;
    $[86] = t46;
  } else {
    t46 = $[86];
  }
  let t47;
  if ($[87] !== showToast || $[88] !== toast) {
    t47 = toast && <DelegationToast toastRef={toastRef} toast={toast} showToast={showToast} setShowToast={setShowToast} />;
    $[87] = showToast;
    $[88] = toast;
    $[89] = t47;
  } else {
    t47 = $[89];
  }
  let t48;
  if ($[90] !== t27 || $[91] !== t46 || $[92] !== t47) {
    t48 = <Container className="pt-4">{t27}{t46}{t47}</Container>;
    $[90] = t27;
    $[91] = t46;
    $[92] = t47;
    $[93] = t48;
  } else {
    t48 = $[93];
  }
  return t48;
}
function EtherscanLink() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href={DELEGATION_CONTRACT.chain_id === sepolia.id ? `https://sepolia.etherscan.io/address/${DELEGATION_CONTRACT.contract}` : `https://etherscan.io/address/${DELEGATION_CONTRACT.contract}`} target="_blank" rel="noopener noreferrer" className={styles.delegationLink}><Image unoptimized={true} src="/etherscan_w.png" alt="etherscan" width={30} height={30} /><span>Etherscan</span></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function GithubLink() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="https://github.com/6529-Collections/nftdelegation" target="_blank" rel="noopener noreferrer" className={styles.delegationLink}><Image unoptimized={true} src="/github_w.png" alt="github" width={30} height={30} /><span>Github</span></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function DelegationToast(props: Readonly<{
  toastRef: React.RefObject<HTMLDivElement | null>;
  toast: {
    title: string;
    message?: string;
  };
  showToast: boolean;
  setShowToast: (show: boolean) => void;
}>) {
  return <div className={styles.toastWrapper} onClick={e => {
    if (!props.toastRef.current?.contains(e.target as Node)) {
      props.setShowToast(false);
    }
  }}>
      <ToastContainer position={"top-center"} className={styles.toast} ref={props.toastRef}>
        <Toast onClose={() => props.setShowToast(false)} show={props.showToast}>
          <Toast.Header>
            <span className="me-auto">{props.toast.title}</span>
          </Toast.Header>
          {props.toast.message && <Toast.Body dangerouslySetInnerHTML={{
          __html: props.toast.message
        }}></Toast.Body>}
        </Toast>
      </ToastContainer>
    </div>;
}